"use strict";
// =========================================================================
// Due Diligence (Gate G1 / S1) — shared option arrays + label constants.
//
// The form itself is defined as a generic FormDefinition (see seed-dd-form.ts
// for the published v1) and rendered by <FormRenderer />. This file only
// keeps the question-option data + confirmation labels so the seed and any
// future tooling (analytics, label generators, etc.) have a single source.
//
// JotForm equivalent: form id 232883218269061 (dev) / 243223705103544 (prod).
// =========================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOV_DRD_LABEL = exports.GOV_DEAN_LABEL = exports.GOV_HOD_LABEL = exports.IP_CONFIRM_BACKGROUND_LABEL = exports.IP_CONFIRM_INTELLECTUAL_LABEL = exports.IP_CONFIRM_FUNDING_LABEL = exports.IP_CONFIRM_AGREEMENTS_LABEL = exports.INNOVUS_CONFIRM_LABEL = exports.ipGeneralConsiderationsOptions = exports.alignmentOptions = exports.commercialisationPreferenceOptions = exports.fundingRealisticOptions = exports.fundingQuantumOptions = exports.accessRatingOptions = exports.capacityOptions = exports.skillsetOptions = exports.freedomToOperateOptions = exports.priorArtOptions = exports.ipLifecycleOptions = exports.IP_NOT_PATENTABLE_OPTION = exports.ipPatentDesignTypes = exports.ipOwnershipOptions = exports.timingOptions = exports.regulatoryRiskOptions = exports.uniqueFeaturesOptions = exports.competingSolutionOptions = exports.domainKnowledgeOptions = exports.feasibilityOptions = exports.trlOptions = exports.viabilityRoiOptions = exports.viabilityRevenueOptions = exports.marketSegmentOptions = exports.marketApplicationOptions = void 0;
// -------- Section 1: Market --------
exports.marketApplicationOptions = [
    { value: 0, label: 'This innovation is purely theoretical' },
    { value: 1, label: 'Any practical application is very unlikely' },
    { value: 2, label: 'Has potential, but no concrete application yet' },
    { value: 3, label: 'One clear promising application' },
    { value: 4, label: 'Multiple promising applications' },
];
exports.marketSegmentOptions = [
    { value: 0, label: 'No real-world market' },
    { value: 1, label: 'Potential buyers, no clear market segment' },
    { value: 2, label: 'A clear market segment has been identified' },
    { value: 3, label: 'Two clear market segments identified' },
    { value: 4, label: 'Several markets have been identified' },
];
// -------- Section 2: Viability --------
exports.viabilityRevenueOptions = [
    { value: 0, label: 'Highly unlikely' },
    { value: 1, label: 'Improbable' },
    { value: 2, label: "It's a coin flip" },
    { value: 3, label: 'Probable' },
    { value: 4, label: 'Excellent' },
];
exports.viabilityRoiOptions = [
    { value: 0, label: 'Highly unlikely' },
    { value: 1, label: 'Improbable' },
    { value: 2, label: '50/50 chance of success' },
    { value: 3, label: 'Probable' },
    { value: 4, label: 'Excellent' },
];
// -------- Section 3: Feasibility --------
exports.trlOptions = [
    { value: 1, label: 'Basic principles observed', disqualifies: true },
    { value: 2, label: 'Technology concept formulated' },
    { value: 3, label: 'Experimental PoC' },
    { value: 4, label: 'Validated in lab' },
    { value: 5, label: 'Validated in relevant environment' },
    { value: 6, label: 'Demonstrated in relevant environment' },
    { value: 7, label: 'System prototype demonstration' },
    { value: 8, label: 'System complete and qualified' },
    { value: 9, label: 'Actual system proven' },
];
exports.feasibilityOptions = [
    { value: 0, label: 'No evidence of feasibility', disqualifies: true },
    { value: 1, label: 'Theoretically feasible' },
    { value: 2, label: 'Experimental evidence' },
    { value: 3, label: 'Practical evidence' },
    { value: 4, label: 'Market-based evidence' },
];
// -------- Section 4: Context --------
exports.domainKnowledgeOptions = [
    { value: 0, label: 'None' },
    { value: 1, label: 'Very little' },
    { value: 2, label: 'Fair' },
    { value: 3, label: 'Good' },
    { value: 4, label: 'Excellent' },
];
exports.competingSolutionOptions = [
    { value: 0, label: 'No competitive analysis was done' },
    { value: 1, label: 'Superior competitive solution exists' },
    { value: 2, label: 'Challenging competitive landscape' },
    { value: 3, label: 'Innovation is likely to outperform competition' },
    { value: 4, label: 'Innovation creates a new market segment' },
];
exports.uniqueFeaturesOptions = [
    { value: 0, label: 'None were identified' },
    { value: 1, label: 'Highly similar to competing solutions' },
    { value: 2, label: 'Minor improvement to a competing solution' },
    { value: 3, label: 'Compelling alternative to competition' },
    { value: 4, label: 'Completely novel innovation' },
];
exports.regulatoryRiskOptions = [
    { value: 0, label: 'Risks were not assessed' },
    { value: 1, label: 'High risk of regulatory clampdown' },
    { value: 2, label: 'Complex regulatory requirements' },
    { value: 3, label: 'Manageable regulatory requirements' },
    { value: 4, label: 'Not affected by regulation' },
];
exports.timingOptions = [
    { value: 0, label: 'No window of opportunity' },
    { value: 1, label: 'Opportunity has likely already passed' },
    { value: 2, label: 'Too early, or late within window of opportunity' },
    { value: 3, label: 'Timing risk can be managed' },
    { value: 4, label: 'Excellent timing' },
];
// -------- Section 5: IP --------
exports.ipOwnershipOptions = [
    { value: 0, label: 'Another party', disqualifies: true },
    { value: 1, label: 'Co-ownership between SU and other party' },
    { value: 2, label: 'Stellenbosch University' },
];
exports.ipPatentDesignTypes = [
    'The innovation is patentable',
    'The innovation incorporates an aesthetic design',
    'The innovation incorporates a functional design',
    'The innovation is not patentable',
];
exports.IP_NOT_PATENTABLE_OPTION = 'The innovation is not patentable';
exports.ipLifecycleOptions = [
    { value: 0, label: 'Too short to require a patent' },
    { value: 1, label: 'Long enough to consider a patent' },
];
exports.priorArtOptions = [
    { value: 0, label: 'No innovation' },
    { value: 1, label: 'Marginal innovation' },
    { value: 2, label: 'Enough novelty to make innovation viable' },
    { value: 3, label: 'Significant novelty; high viability' },
    { value: 4, label: 'Fully patentable' },
];
exports.freedomToOperateOptions = [
    { value: 0, label: 'Existing IP prohibits opportunity' },
    { value: 1, label: 'Significant prior art hurdles' },
    { value: 2, label: 'Licenses must be negotiated' },
    { value: 3, label: 'Low hurdles, e.g. readily licensable prior art' },
    { value: 4, label: 'Full freedom to operate' },
];
// -------- Section 6: Resource Alignment --------
exports.skillsetOptions = [
    { value: 0, label: 'Unable to participate in the opportunity' },
    { value: 1, label: 'Only able to advise on the original concept' },
    { value: 2, label: 'Theoretical skills; significant support required' },
    { value: 3, label: 'Versatile skills; some support required' },
    { value: 4, label: 'Can fully execute on the opportunity' },
];
exports.capacityOptions = [
    { value: 0, label: 'No champion or capacity' },
    { value: 1, label: 'Unclear champion; little capacity' },
    { value: 2, label: 'Champion; some capacity' },
    { value: 3, label: 'Good champion; team may need further support' },
    { value: 4, label: 'Strong, committed team and champion' },
];
exports.accessRatingOptions = [
    { value: 0, label: 'Critical resources lacking' },
    { value: 1, label: 'Critical resources difficult to access' },
    { value: 2, label: 'Resources lacking, but could be obtained' },
    { value: 3, label: 'Well-resourced with access to additional resources' },
    { value: 4, label: 'All resources (incl. funding) available' },
];
// -------- Section 7: Funding --------
exports.fundingQuantumOptions = [
    { value: 0, label: "R100k's" },
    { value: 1, label: "R1m's" },
    { value: 2, label: "R10m's" },
    { value: 3, label: "R100m's" },
];
exports.fundingRealisticOptions = [
    { value: 0, label: 'Project is unfundable' },
    { value: 1, label: 'High risk of not securing funding' },
    { value: 2, label: 'High likelihood of seed- and further funding' },
    { value: 3, label: 'Seed funding already available' },
    { value: 4, label: 'All funding is already committed' },
];
// -------- Section 8: Expectations --------
exports.commercialisationPreferenceOptions = [
    'No interest in commercialisation',
    'Spinout company',
    'License model',
    'Unsure',
    'Other',
];
exports.alignmentOptions = [
    { value: 0, label: 'None' },
    { value: 1, label: 'Very weak' },
    { value: 2, label: 'Some mismatch' },
    { value: 3, label: 'Reasonable' },
    { value: 4, label: 'Perfect' },
];
// -------- General IP considerations (multi-select checkbox group) --------
exports.ipGeneralConsiderationsOptions = [
    'The innovation includes software',
    'The innovation includes copyright works',
    'The innovation already uses a brand or trademark',
];
// -------- Single-checkbox confirmation labels --------
exports.INNOVUS_CONFIRM_LABEL = 'This is in fact an SU owned innovation';
exports.IP_CONFIRM_AGREEMENTS_LABEL = 'All relevant agreements with third parties have been noted and provided to the TTO';
exports.IP_CONFIRM_FUNDING_LABEL = 'Any funding contributions (irrespective of whether a contract was entered) have been noted.';
exports.IP_CONFIRM_INTELLECTUAL_LABEL = 'Any intellectual contribution to the innovation has been noted.';
exports.IP_CONFIRM_BACKGROUND_LABEL = 'Any third-party background IP on which the innovation is based has been noted.';
exports.GOV_HOD_LABEL = 'The disclosure has been signed by all Heads of Department';
exports.GOV_DEAN_LABEL = 'The disclosure has been signed by all Deans of Faculty';
exports.GOV_DRD_LABEL = 'The disclosure has been signed off by the Director: Research Contracts or a delegate';
